// src/utils/statusBadges.jsx
import React from 'react';
import {
  Home,
  Clock,
  Hammer,
  CheckCircle2,
  FileText,
  Calculator,
  Star,
  Users,
  Calendar,
  Key,
  X,
  Target,
  BarChart2,
  Shield,
  DollarSign,
  Building2,
  AlertTriangle,
  ClipboardList,
  FileCheck,
  Wrench,
  ClipboardCheck,
  Tag,
  ShoppingBag,
  Gavel,
  TrendingUp,
} from 'lucide-react';

export const getStatusBadge = (status) => {
  const styles = {
    // ─── Project statuses ───────────────────────────────────────────────
    onboarding: {
      bg: 'bg-purple-100 dark:bg-purple-900/30',
      text: 'text-purple-700 dark:text-purple-300',
      border: 'border-purple-200 dark:border-purple-700',
      label: 'Onboarding',
      icon: Clock,
    },
    rehab: {
      bg: 'bg-amber-100 dark:bg-amber-900/30',
      text: 'text-amber-700 dark:text-amber-300',
      border: 'border-amber-200 dark:border-amber-700',
      label: 'Rehab',
      icon: Hammer,
    },
    active: {
      bg: 'bg-blue-100 dark:bg-blue-900/30',
      text: 'text-blue-700 dark:text-blue-300',
      border: 'border-blue-200 dark:border-blue-700',
      label: 'Active',
      icon: Home,
    },
    undercontract: {
      bg: 'bg-cyan-100 dark:bg-cyan-900/30',
      text: 'text-cyan-700 dark:text-cyan-300',
      border: 'border-cyan-200 dark:border-cyan-700',
      label: 'Under Contract',
      icon: FileText,
    },
    sold: {
      bg: 'bg-emerald-100 dark:bg-emerald-900/30',
      text: 'text-emerald-700 dark:text-emerald-300',
      border: 'border-emerald-200 dark:border-emerald-700',
      label: 'Sold',
      icon: CheckCircle2,
    },
    rehabilitating: {
      bg: 'bg-amber-100 dark:bg-amber-900/30',
      text: 'text-amber-700 dark:text-amber-300',
      border: 'border-amber-200 dark:border-amber-700',
      label: 'Rehab',
      icon: Hammer,
    },
    selling: {
      bg: 'bg-blue-100 dark:bg-blue-900/30',
      text: 'text-blue-700 dark:text-blue-300',
      border: 'border-blue-200 dark:border-blue-700',
      label: 'Active',
      icon: Home,
    },
    // ─── Legacy lead stages (kept for backward compat display) ──────────
    new: {
      bg: 'bg-purple-100 dark:bg-purple-900/30',
      text: 'text-purple-700 dark:text-purple-300',
      border: 'border-purple-200 dark:border-purple-700',
      label: 'New Lead',
      icon: Star,
    },
    analyzing: {
      bg: 'bg-blue-100 dark:bg-blue-900/30',
      text: 'text-blue-700 dark:text-blue-300',
      border: 'border-blue-200 dark:border-blue-700',
      label: 'Analyzing',
      icon: Calculator,
    },
    offer: {
      bg: 'bg-amber-100 dark:bg-amber-900/30',
      text: 'text-amber-700 dark:text-amber-300',
      border: 'border-amber-200 dark:border-amber-700',
      label: 'Offer Made',
      icon: FileText,
    },
    negotiating: {
      bg: 'bg-orange-100 dark:bg-orange-900/30',
      text: 'text-orange-700 dark:text-orange-300',
      border: 'border-orange-200 dark:border-orange-700',
      label: 'Negotiating',
      icon: Users,
    },
    contacted: {
      bg: 'bg-blue-100 dark:bg-blue-900/30',
      text: 'text-blue-700 dark:text-blue-300',
      border: 'border-blue-200 dark:border-blue-700',
      label: 'Contacted',
      icon: Users,
    },
    closing: {
      bg: 'bg-cyan-100 dark:bg-cyan-900/30',
      text: 'text-cyan-700 dark:text-cyan-300',
      border: 'border-cyan-200 dark:border-cyan-700',
      label: 'Closing - 30 Days',
      icon: Calendar,
    },
    pending: {
      bg: 'bg-emerald-100 dark:bg-emerald-900/30',
      text: 'text-emerald-700 dark:text-emerald-300',
      border: 'border-emerald-200 dark:border-emerald-700',
      label: 'Pending Purchase',
      icon: Key,
    },
    won: {
      bg: 'bg-emerald-100 dark:bg-emerald-900/30',
      text: 'text-emerald-700 dark:text-emerald-300',
      border: 'border-emerald-200 dark:border-emerald-700',
      label: 'Won',
      icon: CheckCircle2,
    },
    lost: {
      bg: 'bg-red-100 dark:bg-red-900/30',
      text: 'text-red-700 dark:text-red-300',
      border: 'border-red-200 dark:border-red-700',
      label: 'Lost',
      icon: X,
    },
    // ─── Acquisition pipeline stages ─────────────────────────────────────
    identified: {
      bg: 'bg-violet-100 dark:bg-violet-900/30',
      text: 'text-violet-700 dark:text-violet-300',
      border: 'border-violet-200 dark:border-violet-700',
      label: 'Initial Analysis',
      icon: Target,
    },
    underwriting: {
      bg: 'bg-blue-100 dark:bg-blue-900/30',
      text: 'text-blue-700 dark:text-blue-300',
      border: 'border-blue-200 dark:border-blue-700',
      label: 'Offer',
      icon: FileText,
    },
    inspection: {
      bg: 'bg-amber-100 dark:bg-amber-900/30',
      text: 'text-amber-700 dark:text-amber-300',
      border: 'border-amber-200 dark:border-amber-700',
      label: 'Inspection',
      icon: ClipboardCheck,
    },
    final_underwriting: {
      bg: 'bg-orange-100 dark:bg-orange-900/30',
      text: 'text-orange-700 dark:text-orange-300',
      border: 'border-orange-200 dark:border-orange-700',
      label: 'Final Underwriting',
      icon: Calculator,
    },
    pending_purchase: {
      bg: 'bg-emerald-100 dark:bg-emerald-900/30',
      text: 'text-emerald-700 dark:text-emerald-300',
      border: 'border-emerald-200 dark:border-emerald-700',
      label: 'Pending Purchase',
      icon: Key,
    },
    // Approval pipeline (enterprise)
    cfo_review: {
      bg: 'bg-amber-100 dark:bg-amber-900/30',
      text: 'text-amber-700 dark:text-amber-300',
      border: 'border-amber-200 dark:border-amber-700',
      label: 'Deal Review',
      icon: BarChart2,
    },
    ceo_approval: {
      bg: 'bg-orange-100 dark:bg-orange-900/30',
      text: 'text-orange-700 dark:text-orange-300',
      border: 'border-orange-200 dark:border-orange-700',
      label: 'Final Approval',
      icon: Shield,
    },
    funding_confirmed: {
      bg: 'bg-cyan-100 dark:bg-cyan-900/30',
      text: 'text-cyan-700 dark:text-cyan-300',
      border: 'border-cyan-200 dark:border-cyan-700',
      label: 'Funding Secured',
      icon: DollarSign,
    },
    acquired: {
      bg: 'bg-emerald-100 dark:bg-emerald-900/30',
      text: 'text-emerald-700 dark:text-emerald-300',
      border: 'border-emerald-200 dark:border-emerald-700',
      label: 'Acquired',
      icon: Building2,
    },
    rejected: {
      bg: 'bg-red-100 dark:bg-red-900/30',
      text: 'text-red-700 dark:text-red-300',
      border: 'border-red-200 dark:border-red-700',
      label: 'Rejected',
      icon: AlertTriangle,
    },
    // ─── Rehab phase statuses ──────────────────────────────────────────────
    planning: {
      bg: 'bg-slate-100 dark:bg-slate-900/30',
      text: 'text-slate-700 dark:text-slate-300',
      border: 'border-slate-200 dark:border-slate-700',
      label: 'Planning',
      icon: ClipboardList,
    },
    permits: {
      bg: 'bg-amber-100 dark:bg-amber-900/30',
      text: 'text-amber-700 dark:text-amber-300',
      border: 'border-amber-200 dark:border-amber-700',
      label: 'Permits',
      icon: FileCheck,
    },
    in_progress: {
      bg: 'bg-blue-100 dark:bg-blue-900/30',
      text: 'text-blue-700 dark:text-blue-300',
      border: 'border-blue-200 dark:border-blue-700',
      label: 'In Progress',
      icon: Wrench,
    },
    punch_list: {
      bg: 'bg-orange-100 dark:bg-orange-900/30',
      text: 'text-orange-700 dark:text-orange-300',
      border: 'border-orange-200 dark:border-orange-700',
      label: 'Punch List',
      icon: ClipboardCheck,
    },
    rehab_complete: {
      bg: 'bg-emerald-100 dark:bg-emerald-900/30',
      text: 'text-emerald-700 dark:text-emerald-300',
      border: 'border-emerald-200 dark:border-emerald-700',
      label: 'Rehab Complete',
      icon: CheckCircle2,
    },
    // ─── Selling phase statuses ────────────────────────────────────────────
    pre_listing: {
      bg: 'bg-purple-100 dark:bg-purple-900/30',
      text: 'text-purple-700 dark:text-purple-300',
      border: 'border-purple-200 dark:border-purple-700',
      label: 'Pre-Listing',
      icon: Tag,
    },
    on_market: {
      bg: 'bg-blue-100 dark:bg-blue-900/30',
      text: 'text-blue-700 dark:text-blue-300',
      border: 'border-blue-200 dark:border-blue-700',
      label: 'On Market',
      icon: ShoppingBag,
    },
    under_contract: {
      bg: 'bg-cyan-100 dark:bg-cyan-900/30',
      text: 'text-cyan-700 dark:text-cyan-300',
      border: 'border-cyan-200 dark:border-cyan-700',
      label: 'Under Contract',
      icon: Gavel,
    },
    closing: {
      bg: 'bg-indigo-100 dark:bg-indigo-900/30',
      text: 'text-indigo-700 dark:text-indigo-300',
      border: 'border-indigo-200 dark:border-indigo-700',
      label: 'Closing',
      icon: Clock,
    },
    sold: {
      bg: 'bg-emerald-100 dark:bg-emerald-900/30',
      text: 'text-emerald-700 dark:text-emerald-300',
      border: 'border-emerald-200 dark:border-emerald-700',
      label: 'Sold',
      icon: CheckCircle2,
    },
  };
  const style = styles[status] || styles.onboarding;
  const Icon = style.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold ${style.bg} ${style.text} border ${style.border}`}
    >
      <Icon size={12} />
      {style.label}
    </span>
  );
};

export const getStatusLabel = (status) => {
  const labels = {
    onboarding: 'Onboarding',
    rehab: 'Rehab',
    active: 'Active',
    undercontract: 'Under Contract',
    sold: 'Sold',
    rehabilitating: 'Rehab',
    selling: 'Active',
    listed: 'Listed',
    closing: 'Closing',
    planning: 'Planning',
    permits: 'Permits',
    in_progress: 'In Progress',
    punch_list: 'Punch List',
  };
  return labels[status] || status;
};
